import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteScrollDirective } from './autocomplete-scroll.directive';



@NgModule({
  declarations: [AutocompleteScrollDirective],
  imports: [
    CommonModule
  ],
  exports: [AutocompleteScrollDirective],
})
export class AutocompleteScrollModule { }
